var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"result-booking"},[_c('b-card-text',{staticClass:"empty breadcrumb-text"},[_vm._v(" no result obtained please try the correct ID ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }